import articleData from "./blogArticles.json";

export type BlogArticle = {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  date: string;
  isoDate: string;
  image: string | null;
  state?: "CA" | "FL" | "TX" | "NY" | "NJ" | "MULTI" | "GENERIC";
  provider?: "soro" | "autoblog";
  author?: string;
  updatedAt?: string;
};

export const blogArticles = articleData as BlogArticle[];

export const blogArticleBySlug = new Map(blogArticles.map((article) => [article.slug, article]));

export const blogArticlePath = (slug: string) => `/blog/${slug}/`;
